module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-100.d1fc00a3.svg";